import * as suspensionApi from "@hub/management/src/modules/suspensions/api/suspension.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const fetchSuspensions = async params => {
  try {
    const data = await suspensionApi.fetchSuspensions(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível buscar a lista de suspensões"
    })
    throw error
  }
}

export const fetchUsersForSuspension = async () => {
  try {
    const data = await suspensionApi.fetchUsersForSuspension()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível buscar a lista de usuários"
    })
    throw error
  }
}

export const createSuspension = async params => {
  try {
    const data = await suspensionApi.createSuspension(params)
    if (data.message) {
      window.$vue.$toast({
        type: "success",
        title: data.message
      })
    }
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível criar a suspensão"
    })
    throw error
  }
}

export const cancelSuspension = async (uuid, reason) => {
  try {
    const data = await suspensionApi.cancelSuspension(uuid, reason)
    if (data.message) {
      window.$vue.$toast({
        type: "success",
        title: data.message
      })
    }
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível cancelar a suspensão"
    })
    throw error
  }
}

export const fetchSuspensionDetails = async uuid => {
  try {
    const data = await suspensionApi.fetchSuspensionDetails(uuid)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível buscar os detalhes da suspensão"
    })
    throw error
  }
}

export const fetchIndicators = async () => {
  try {
    const data = await suspensionApi.fetchIndicators()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível buscar os indicadores"
    })
    throw error
  }
}

export const fetchSuspensionTypes = async () => {
  try {
    const data = await suspensionApi.fetchSuspensionTypes()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Não foi possível buscar os tipos de suspensão"
    })
    throw error
  }
}
